<template>
  <teleport to="body">
    <div v-if="isOpen" class="modal-backdropers" @click="closeModal">
      <div class="modal fade show" :class="{ show: isOpen }" :style="{ display: isOpen ? 'block' : 'none' }" @click.stop>
        <div v-bind:class="'modal-dialog '+modalWidth">
          <div class="modal-content">
            <!-- Slot para el encabezado del modal -->
            <slot name="header" v-if="modalHead"> </slot>
            <!-- Cuerpo del modal (contenido dinámico) -->
            <div class="modal-body text-left p-0 scrollable-modal-body">
              <slot name="body"></slot>
            </div>
            <!-- Pie del modal con los botones de acción -->
            <div class="modal-footer" v-if="modalFooter">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts" setup>
  import { onMounted, onBeforeUnmount } from "vue";

     defineProps<{
      isOpen: boolean,
      modalFooter: boolean,//[True] shows the modal footer
      modalHead: boolean//[True] shows the modal Head
      modalWidth?: string // opcional para el ancho del modal
    }>();

    const emit = defineEmits<{ (e: 'close'): void }>();

  
    const handleEsc = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        emit('close');
      }
    };

    onMounted(() => document.addEventListener('keydown', handleEsc));
    onBeforeUnmount(() => document.removeEventListener('keydown', handleEsc));

    const closeModal = () => {   emit('close'); };
</script>

